'use strict';
module.exports = {
	info: 'ℹ️',
	success: '✅',
	warning: '⚠️',
	error: '❌️'
};



//////////////////
// WEBPACK FOOTER
// ./~/log-symbols/browser.js
// module id = 84R7
// module chunks = 3